import React from 'react';
import styled from 'styled-components/native';
import { AppLottieView } from '@/components/base/app.lottie.view';
import { useAssets } from '@/hooks/use.assets';
import { Box } from '@/components/base/box';
import type { LottieViewProps } from 'lottie-react-native/src/types';

interface Props extends Partial<LottieViewProps> {
  size?: 'normal' | 'large';
}
function BaseAppSpinner({ size = 'normal', style, ...props }: Props) {
  const assets = useAssets();
  const Parent = size === 'normal' ? SpinnerContainer : SpinnerContainerLarge;

  return (
    <Parent {...props} style={style}>
      <LottieView loop autoPlay source={assets.animations.spinner} />
    </Parent>
  );
}

const SpinnerContainer = styled(Box)`
  width: 25px;
  height: 25px;
  align-items: center;
  justify-content: center;
`;

const SpinnerContainerLarge = styled(SpinnerContainer)`
  width: 45px;
  height: 45px;
`;

const LottieView = styled(AppLottieView)`
  width: 110%;
  height: 110%;
`;

export const AppSpinner = React.memo(BaseAppSpinner);
